<template>
  <div class="footer f-nor">
    <div class="topContainer flex-c flex-column">
      <div class="logo">
        <img src="@/assets/logo.png" alt="logo" class="logoImg" loading="lazy">QuickFondo
      </div>
      <div class="nav d-flex ali-c just-ar">
        <div class="name" @click="$router.push('/')">Inicio</div>
        <div class="name" @click="$router.push('/product')">Préstamos</div>
        <div class="name" @click="$router.push('/question')">Ayuda</div>
        <div class="name" @click="$router.push('/politica')">Política de Privacidad</div>
        <div class="name" @click="$router.push('/terminos')">Términos de Servicio</div>
        <div class="name" @click="$router.push('/account')">Datos de cuenta</div>
      </div>
      <div class="message d-flex ali-c just-ar">
        <div><img src="@/assets/images/time.svg" loading="lazy" alt="time" class="icon">De lunes a viernes 9:30 - 18:30
        </div>
        <div><img src="@/assets/images/email.svg" loading="lazy" alt="email" class="icon">hola@quickfondo.com</div>
        <div><img src="@/assets/images/address.svg" loading="lazy" alt="address" class="icon">LAGO MICHIGAN MZ 33, LT
          32, JARDINES DE
          MORELOS SECCION LAGOS,ECATEPEC DE MORELOS, C. P. 55070</div>
      </div>
      <img src="@/assets/images/googleBtn.webp" loading="lazy" alt="googleBtn" class="googleBtn" @click="rediectTo">
    </div>
    <div class="btmContainer flex-c">Todos los derechos reservados © 2025 QuickFondo</div>
  </div>
</template>

<script>
export default {
  methods: {
    rediectTo() {
      window.location.href = 'https://play.google.com/store/apps/details?id=com.quick.fondo.prestamo.rapido.credito.dinero&hl=es-419&gl=mx'
    }
  }
}
</script>

<style lang="less" scoped>
.footer {
  width: 100%;
  // height: 24.8438vw;
  background: #070710;
  .topContainer {
    height: 20.4688vw;
    padding: 3.6458vw;
    .logo {
      color: #fff;
      text-align: center;
      font-family: "Poppins";
      font-size: 1.25vw;
      font-weight: 600;
      .logoImg {
        width: 2.0833vw;
        margin-right: 1vw;
      }
    }
    .nav {
      margin-top: 2vw;
      width: 50%;
      color: rgba(255, 255, 255, 0.88);
      font-size: 0.8333vw;
      font-weight: 400;
      .name {
        cursor: pointer;
      }
    }
    .message {
      margin-top: 2vw;
      color: rgba(255, 255, 255, 0.88);
      font-size: 0.8333vw;
      font-weight: 400;
      .icon {
        margin-left: 3vw;
        width: 0.9375vw;
      }
    }
    .googleBtn {
      margin-top: 2vw;
      cursor: pointer;
    }
  }
  .btmContainer {
    margin: 0 6.25vw;
    border-top: 1px solid rgba(255, 255, 255, 0.15);
    padding: 1.6667vw 0;
    color: rgba(255, 255, 255, 0.35);
    text-align: center;
    font-size: 0.8333vw;
    font-weight: 400;
  }
}


@media (max-width: 768px) {
  .footer {
    padding: 5vw 0;
    .topContainer {
      height: auto!important;
      padding: 5vw 6.25vw;
      .logo {
        font-size: 4vw!important;
        margin-bottom: 4vw!important;
        .logoImg {
          width: 10vw!important;
        }
      }
      .nav {
        display: none;
      }
      .message {
        font-size: 2.5vw!important;
        display: block;
        div {
          margin-bottom: 2vw;
          line-height: 2;
        }
        .icon {
          width: 3vw!important;
          margin-right: 2vw;
          margin-left: 0;
        }
      }
      .googleBtn {
        margin-top: 4vw!important;
        width: 35vw!important;
      }
    }
    .btmContainer {
      font-size: 2.5vw!important;
      line-height: 2;
    }
  }
}
</style>